import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { EmailForm, PasswordForm } from './components/Login';
import * as c from './constants';

import './style.scss';

const Login = ({
  metadata,
  translations,
  resetStep,
  onClearError,
  hogar,
  onSubmit,
  isLoading,
  error,
  region,
}) => {
  const [activeStep, setActiveStep] = useState(c.STEPS.EMAIL_FORM);
  const [form, setForm] = useState({});
  const keyHboMax = JSON.parse(get(metadata, 'externalLogin_linking', '{}'));
  const hboMaxByCountry = get(keyHboMax, region, get(keyHboMax, 'default'));
  const hboMaxIsEnabled = get(
    hboMaxByCountry,
    'hbo.default',
    get(hboMaxByCountry, 'default.default'),
  );

  useEffect(
    () => {
      setActiveStep(c.STEPS.EMAIL_FORM);
    },
    [resetStep],
  );

  const handleSubmit = async params => {
    onSubmit(params, { hogar });
  };

  const processSubmitAction = async (submitAction, values) => {
    switch (submitAction) {
      case c.SUBMIT_TYPES.next:
        setActiveStep(activeStep + 1);
        break;
      case c.SUBMIT_TYPES.cancel:
        setActiveStep(c.STEPS.EMAIL_FORM);
        break;
      case c.SUBMIT_TYPES.validateEmail:
        setActiveStep(c.STEPS.PASSWORD_FORM);
        break;
      case c.SUBMIT_TYPES.submit: {
        const body = { ...form, password: values.password };
        setForm({ ...body });
        await handleSubmit(body);
        break;
      }
      case c.SUBMIT_TYPES.done:
        break;
      default:
        throw new Error(`Submit action ${submitAction} not supported`);
    }
  };
  const getActiveComponent = () => {
    switch (activeStep) {
      case c.STEPS.EMAIL_FORM:
        return (
          <EmailForm
            translations={translations}
            hogar={hogar}
            region={region}
            hboMaxIsEnabled={hboMaxIsEnabled}
            onNextClicked={values => {
              setForm({ ...form, email: values.emailRegister });
              processSubmitAction(c.SUBMIT_TYPES.validateEmail);
            }}
          />
        );
      case c.STEPS.PASSWORD_FORM:
        return (
          <PasswordForm
            error={error}
            isLoading={isLoading}
            translations={translations}
            hogar={hogar}
            region={region}
            hboMaxIsEnabled={hboMaxIsEnabled}
            onClearError={onClearError}
            onCancelClicked={() => {
              onClearError();
              processSubmitAction(c.SUBMIT_TYPES.cancel);
            }}
            onNextClicked={values => {
              onClearError();
              processSubmitAction(c.SUBMIT_TYPES.submit, values);
            }}
          />
        );
      default:
        throw new Error(`Step ${activeStep} not supported`);
    }
  };

  return (
    <div>
      <div className="hbo-landingPage">
        <div>{getActiveComponent()}</div>
      </div>
    </div>
  );
};

Login.propTypes = {
  region: PropTypes.string,
  hogar: PropTypes.bool,
  onSubmit: PropTypes.func,
  resetStep: PropTypes.bool,
  onClearError: PropTypes.func,
  translations: PropTypes.object,
  error: PropTypes.object,
};

export default Login;
